import React from "react";
import "@/index.css";
import AppRouter from "@/router/AppRouter";

function App() {
    return <AppRouter />;
}

export default App;
